import { render } from "./BankAutocompleteSuggestionWithIspb.vue?vue&type=template&id=088659f4"
import script from "./BankAutocompleteSuggestionWithIspb.vue?vue&type=script&lang=js"
export * from "./BankAutocompleteSuggestionWithIspb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__